<template>
  <div id="surveyjsEditorContainer" />
</template>

<script>
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";

const creatorOptions = {
  showJSONEditorTab: false,
  showLogicTab: false,
  showPropertyGrid: false,
  isAutoSave: true,
  showPageSelector: false,
  allowModifyPages: false,
  showPagesToolbox: false,
  pageEditMode: "standard",
  haveCommercialLicense: true,
  readOnly: false,
  questionTypes: [
    "text",
    "checkbox",
    "panel",
    "radiogroup",
    "boolean",
    "comment",
    "rating",
    "expression",
    "signaturepad",
  ],
};

export default {
  name: "MaintenanceEditor",
  props: {
    template: Object,
    type: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      modifyData: { logoError: null},
      creator: null
    }
  },
  mounted() {
    const SurveyCreator = require('survey-creator-knockout');

    if(this.isDisabled) {
      creatorOptions.readOnly = true;
    } else {
      creatorOptions.readOnly = false;
    }

    this.creator = new SurveyCreator.SurveyCreator(creatorOptions);

    this.creator.onModified.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onActiveTabChanging.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onActiveTabChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onSelectedElementChanging.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onPropertyChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onSelectedElementChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onQuestionAdded.add((sender, options) => {
      if(!options.question) return;
      const val = options.question.name;
      options.question.name = val.charAt(0).toUpperCase() + val.slice(1);
    })

    this.creator.text = this.template.template;

    this.creator.saveSurveyFunc = () => {
      if(this.type === "Template") {
        this.$store.commit("updateMaintenanceTemplateContent", this.creator.text);
      }

      if(this.type === "Form") {
        this.$store.commit("updateMaintenanceFormContent", this.creator.text);
      }
    };

    this.creator.render("surveyjsEditorContainer");
  },
  destroyed() {
    const container = document.getElementById("surveyjsEditorContainer")

    if (container) {
      container.innerHTML = "";
    }

    if (this.creator) {
      this.creator.dispose();
      this.creator = null;
    }
  },
  watch: {
    isDisabled(newVal) {
      if (this.creator) {
        this.creator.readOnly = newVal;
      }
    }
  }
}
</script>

<style scoped>

</style>